import { useGetUser } from './use-get-user';
// avoiding having to `useCallback` the `select`.
const select = (data) => data.role;
export const useUserRole = (options) => useGetUser(undefined, {
    select,
    ...options,
}).data;
//# sourceMappingURL=use-user-role.js.map